import { render, staticRenderFns } from "./UserNociteDetails.vue?vue&type=template&id=2c50b186&scoped=true"
import script from "./UserNociteDetails.vue?vue&type=script&lang=js"
export * from "./UserNociteDetails.vue?vue&type=script&lang=js"
import style0 from "./UserNociteDetails.vue?vue&type=style&index=0&id=2c50b186&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50b186",
  null
  
)

export default component.exports